const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const resolveApiBaseUrl = () => {
	const rawEnvUrl = process.env.REACT_APP_API_URL;
	const envUrl = rawEnvUrl ? trimTrailingSlash(rawEnvUrl) : '';
	const isLocalRuntime = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

	if (isLocalRuntime) {
		const localBase = `${window.location.protocol}//${window.location.hostname}:8080`;
		if (envUrl && !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1')) {
			console.error(`[Config] REACT_APP_API_URL is '${envUrl}' but runtime is localhost. Forcing local API base '${localBase}'.`);
		}
		return localBase;
	}

	if (!envUrl) {
		throw new Error('REACT_APP_API_URL is required outside localhost runtime.');
	}

	return envUrl;
};

export const serverURI = `${resolveApiBaseUrl()}/`;
export const domain = "cobs.ccprcentre.org";
